(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
var fullVideo = new Boulies.PopupModal({
    container: '.bt31-fvContainer',
    background: '.bt31-fvBg',
    content: '.bt31-fvContent',
    openBTN: '.bt31-fvOpen',
    closeBTN: '.bt31-fvClose',
    beforeClose: function(){
        document.querySelector('#bt31-fullCollectionVideo').pause();
    }
})
fullVideo.initModal();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customize--newsletter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const newsletter_btn = document.querySelector('.newsletter-popbtn');
    if (!newsletter_btn || newsletter_btn.dataset.active == 'false') return;

    if (typeof $ === 'undefined' || typeof $.cookie !== 'function' || typeof $.post !== 'function') return;

    const newsletter_bg = document.querySelector('.newsletter-background');
    const newsletter_popup = document.querySelector('.newsletter-container');
    const newsletter_success = document.querySelector('.newsletter-success-note');
    const newsletter_close_trigger = document.querySelectorAll('.newsletter-close-trigger');
    const newsletter_submit = document.querySelector('.newsletter-submit');
    const newsletter_finish = document.querySelector('.newsletter-finish');

    if (!newsletter_bg || !newsletter_popup || !newsletter_success || !newsletter_submit || !newsletter_finish) return;

    const open_newsletter = function () {
      newsletter_bg.style.display = 'block';
      newsletter_popup.style.display = 'flex';
      setTimeout(function () {
        newsletter_bg.classList.add('newsletter-actived');
        newsletter_popup.classList.add('newsletter-actived');
      }, 10);
    };

    const close_newsletter = function () {
      newsletter_bg.classList.remove('newsletter-actived');
      newsletter_popup.classList.remove('newsletter-actived');
      newsletter_success.classList.remove('newsletter-actived');
      setTimeout(function () {
        newsletter_bg.style.display = 'none';
        newsletter_popup.style.display = 'none';
        newsletter_success.style.display = 'none';
      }, 350);
    };

    const show_newsletter_btn = function () {
      newsletter_btn.style.display = 'flex';
      setTimeout(function () {
        newsletter_btn.classList.add('newsletter-actived');
      }, 10);
    };

    const close_newsletter_btn = function () {
      newsletter_btn.classList.remove('newsletter-actived');
      setTimeout(function () {
        newsletter_btn.style.display = 'none';
      }, 350);
    };

    newsletter_btn.addEventListener('click', function (e) {
      if (e.target.closest('.newsletter-popbtn--content-wrap')) {
        open_newsletter();
      }
      if (e.target.closest('.newsletter-pop-btn--close')) {
        close_newsletter_btn();
        $.cookie('boulies_newsletter', true, {
          path: '/',
        });
      }
    });

    newsletter_close_trigger.forEach((trigger) => {
      trigger.addEventListener('click', function () {
        close_newsletter();
      });
    });

    const validateEmail = function (email) {
      return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    };

    newsletter_submit.addEventListener('click', async function () {
      const error_message = document.querySelector('.newsletter-error');
      const email = document.querySelector('.newsletter-email');
      if (!error_message || !email) return;

      error_message.style.display = 'none';
      if (!validateEmail(email.value)) {
        error_message.innerHTML =
          '<b>Ungültige E-Mail-Adresse</b><br>Bitte geben Sie eine gültige E-Mail-Adresse ein. ';
        error_message.style.display = 'block';
        return false;
      }

      this.innerHTML =
        '<svg class="loading-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M512 74.666667c-17.066667 0-32 14.933333-32 32v149.333333c0 17.066667 14.933333 32 32 32s32-14.933333 32-32V106.666667c0-17.066667-14.933333-32-32-32zM693.333333 362.666667c8.533333 0 17.066667-2.133333 23.466667-8.533334l104.533333-104.533333c12.8-12.8 12.8-32 0-44.8-12.8-12.8-32-12.8-44.8 0l-104.533333 104.533333c-12.8 12.8-12.8 32 0 44.8 4.266667 6.4 12.8 8.533333 21.333333 8.533334zM917.333333 480h-149.333333c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h149.333333c17.066667 0 32-14.933333 32-32s-14.933333-32-32-32zM714.666667 669.866667c-12.8-12.8-32-12.8-44.8 0s-12.8 32 0 44.8l104.533333 104.533333c6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466666-8.533333c12.8-12.8 12.8-32 0-44.8l-106.666666-104.533333zM512 736c-17.066667 0-32 14.933333-32 32v149.333333c0 17.066667 14.933333 32 32 32s32-14.933333 32-32v-149.333333c0-17.066667-14.933333-32-32-32zM309.333333 669.866667l-104.533333 104.533333c-12.8 12.8-12.8 32 0 44.8 6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466666-8.533333l104.533334-104.533333c12.8-12.8 12.8-32 0-44.8s-36.266667-12.8-46.933334 0zM288 512c0-17.066667-14.933333-32-32-32H106.666667c-17.066667 0-32 14.933333-32 32s14.933333 32 32 32h149.333333c17.066667 0 32-14.933333 32-32zM247.466667 202.666667c-12.8-12.8-32-12.8-44.8 0-12.8 12.8-12.8 32 0 44.8l104.533333 104.533333c6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466666-8.533333c12.8-12.8 12.8-32 0-44.8l-106.666666-104.533333z" fill="#ffffff" ></path></svg>';

      const subscribe_response = await $.post('https://app.boulies.com/api/subscribe', {
        email: email.value,
        shop: Shopify.shop,
      });
      if (subscribe_response.code == 200) {
        newsletter_popup.classList.remove('newsletter-actived');
        newsletter_success.style.display = 'flex';
        close_newsletter_btn();
        $.cookie('boulies_newsletter', true, {
          path: '/',
        });
        setTimeout(function () {
          newsletter_popup.style.display = 'none';
          newsletter_success.classList.add('newsletter-actived');
        }, 320);
      } else {
        error_message.innerHTML = subscribe_response.msg;
        console.log(subscribe_response.err);
        error_message.style.display = 'block';
      }
      this.innerHTML = 'ANMELDEN';
    });

    newsletter_finish.addEventListener('click', function () {
      close_newsletter();
      close_newsletter_btn();
    });

    if (!$.cookie('boulies_newsletter')) {
      setTimeout(function () {
        show_newsletter_btn();
      }, 31000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customize--sale-note-banner"] && !Shopify.designMode) return;
  try {
    
  const note_bar = document.querySelector('.b5-sale-note-bar');
  if (note_bar) {
    const note_bar_startDate = new Date(note_bar.dataset.start).getTime();
    const note_bar_endDate = new Date(note_bar.dataset.end).getTime();
    const note_bar_localDate = new Date().getTime();
    if (
      !Number.isNaN(note_bar_startDate) &&
      !Number.isNaN(note_bar_endDate) &&
      note_bar_startDate < note_bar_localDate &&
      note_bar_endDate > note_bar_localDate
    ) {
      note_bar.style.opacity = 0.9;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const notiBar = document.querySelector('.top-notify');
  const header = document.querySelector('.bt5-header');

  if (notiBar && header) {
    const bindCloseAction = function (targetBar) {
      const closeButton = targetBar.querySelector('.top-notify__close-btn');

      if (closeButton) {
        closeButton.addEventListener('click', function () {
          targetBar.style.display = 'none';
        });
      }
    };

    if (header.classList.contains('product')) {
      const newNotiBar = notiBar.cloneNode(true);
      const headerNotifyBarWrap = document.querySelector('.header-notify-bar-wrap');
      const productNotifyBarWrap = document.querySelector('.product-notify-bar-wrap');

      if (headerNotifyBarWrap && productNotifyBarWrap) {
        headerNotifyBarWrap.removeChild(notiBar);
        productNotifyBarWrap.appendChild(newNotiBar);
        newNotiBar.style.display = 'flex';
        bindCloseAction(newNotiBar);
      }
    } else {
      notiBar.style.display = 'flex';
      bindCloseAction(notiBar);
    }
  }

  (function () {
    var desktopProductsMenu = document.querySelector('.bt5-products-menu');
    var defaultTabKey = 'gaming';
    var initialActiveTab = desktopProductsMenu
      ? desktopProductsMenu.querySelector('[data-products-menu-tab].is-active')
      : null;
    var initialTabKey = initialActiveTab ? initialActiveTab.getAttribute('data-products-menu-tab') : defaultTabKey;
    var tabs;
    var panels;

    if (!desktopProductsMenu || desktopProductsMenu.dataset.desktopProductsMenuReady === 'true') {
      return;
    }

    tabs = Array.prototype.slice.call(desktopProductsMenu.querySelectorAll('[data-products-menu-tab]'));
    panels = Array.prototype.slice.call(desktopProductsMenu.querySelectorAll('[data-products-menu-panel]'));

    if (!tabs.length || !panels.length) {
      return;
    }

    desktopProductsMenu.dataset.desktopProductsMenuReady = 'true';

    function setActiveProductsTab(tabKey) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-products-menu-tab') === tabKey;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-products-menu-panel') === tabKey;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    tabs.forEach(function (tab) {
      var tabKey = tab.getAttribute('data-products-menu-tab');
      tab.setAttribute('aria-pressed', tabKey === initialTabKey ? 'true' : 'false');
      tab.addEventListener('mouseenter', function () {
        setActiveProductsTab(tabKey);
      });
      tab.addEventListener('focus', function () {
        setActiveProductsTab(tabKey);
      });
      tab.addEventListener('click', function () {
        setActiveProductsTab(tabKey);
      });
    });

    setActiveProductsTab(initialTabKey);
  })();

  (function () {
    var sliderMenu = document.querySelector('.bt5-slider-menu');
    var drawer = document.querySelector('.header-mobile-drawer');
    var closeTrigger = sliderMenu ? sliderMenu.querySelector('.js-slider-close-trigger') : null;
    var accordion = drawer ? drawer.querySelector('[data-drawer-accordion]') : null;
    var drawerStateStorageKey = 'bt5-mobile-drawer-state';
    if (!sliderMenu || !drawer || drawer.dataset.mobileDrawerReady === 'true') {
      return;
    }

    drawer.dataset.mobileDrawerReady = 'true';

    sliderMenu.addEventListener('click', function (event) {
      if (!drawer.contains(event.target) && closeTrigger) {
        closeTrigger.click();
      }
    });

    function clearPanelAnimation(panel) {
      if (!panel || !panel._drawerTransitionHandler) {
        return;
      }

      panel.removeEventListener('transitionend', panel._drawerTransitionHandler);
      panel._drawerTransitionHandler = null;
    }

    function syncPanelState(panel, expanded) {
      if (!panel) {
        return;
      }

      clearPanelAnimation(panel);
      panel.dataset.expanded = expanded ? 'true' : 'false';
      panel.hidden = !expanded;
      panel.style.maxHeight = expanded ? 'none' : '';
      panel.style.overflow = '';
    }

    function animatePanel(panel, expanded) {
      var startHeight;
      var targetHeight;

      if (!panel) {
        return;
      }

      clearPanelAnimation(panel);

      if (expanded) {
        startHeight = panel.hidden ? 0 : panel.getBoundingClientRect().height;
        panel.hidden = false;
        panel.style.overflow = 'hidden';
        panel.style.maxHeight = startHeight + 'px';
        panel.dataset.expanded = 'true';
        targetHeight = panel.scrollHeight;
        void panel.offsetHeight;
        panel.style.maxHeight = targetHeight + 'px';
        panel._drawerTransitionHandler = function (event) {
          if (event.target !== panel || event.propertyName !== 'max-height') {
            return;
          }

          clearPanelAnimation(panel);
          panel.style.maxHeight = 'none';
          panel.style.overflow = '';
        };
        panel.addEventListener('transitionend', panel._drawerTransitionHandler);
        return;
      }

      if (panel.hidden) {
        syncPanelState(panel, false);
        return;
      }

      startHeight = panel.getBoundingClientRect().height;
      panel.style.overflow = 'hidden';
      panel.style.maxHeight = startHeight + 'px';
      void panel.offsetHeight;
      panel.dataset.expanded = 'false';
      panel.style.maxHeight = '0px';
      panel._drawerTransitionHandler = function (event) {
        if (event.target !== panel || event.propertyName !== 'max-height') {
          return;
        }

        clearPanelAnimation(panel);
        panel.hidden = true;
        panel.style.maxHeight = '';
        panel.style.overflow = '';
      };
      panel.addEventListener('transitionend', panel._drawerTransitionHandler);
    }

    function setSectionState(trigger, expanded) {
      var group = trigger.closest('[data-drawer-group]');
      var panel = group ? group.querySelector('[data-drawer-section-panel]') : null;

      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      if (panel) {
        animatePanel(panel, expanded);
      }
    }

    function setCategoryState(item, expanded) {
      var trigger = item ? item.querySelector('[data-drawer-category-trigger]') : null;
      var panel = item ? item.querySelector('[data-drawer-category-panel]') : null;

      if (!trigger || !panel) {
        return;
      }

      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      animatePanel(panel, expanded);
    }

    function readDrawerState() {
      var rawState;

      try {
        rawState = window.sessionStorage.getItem(drawerStateStorageKey);
      } catch (error) {
        return null;
      }

      if (!rawState) {
        return null;
      }

      try {
        return JSON.parse(rawState);
      } catch (error) {
        return null;
      }
    }

    function persistDrawerState() {
      var state = {
        sections: {},
        openCategory: null,
      };
      var groups = drawer.querySelectorAll('[data-drawer-group]');
      var categoryItems;
      var group;
      var trigger;
      var item;
      var sectionId;
      var categoryId;

      for (var index = 0; index < groups.length; index++) {
        group = groups[index];
        trigger = group.querySelector('[data-drawer-section-trigger]');
        sectionId = group.getAttribute('data-drawer-section-id');

        if (trigger && sectionId) {
          state.sections[sectionId] = trigger.getAttribute('aria-expanded') === 'true';
        }
      }

      if (accordion) {
        categoryItems = accordion.querySelectorAll('[data-drawer-category]');

        for (var itemIndex = 0; itemIndex < categoryItems.length; itemIndex++) {
          item = categoryItems[itemIndex];
          trigger = item.querySelector('[data-drawer-category-trigger]');
          categoryId = item.getAttribute('data-drawer-category-id');

          if (trigger && categoryId && trigger.getAttribute('aria-expanded') === 'true') {
            state.openCategory = categoryId;
            break;
          }
        }
      }

      try {
        window.sessionStorage.setItem(drawerStateStorageKey, JSON.stringify(state));
      } catch (error) {}
    }

    function restoreDrawerState() {
      var state = readDrawerState();
      var groups;
      var categoryItems;
      var group;
      var trigger;
      var item;
      var sectionId;
      var categoryId;
      var hasMatchedCategory = false;

      if (!state) {
        return;
      }

      groups = drawer.querySelectorAll('[data-drawer-group]');

      for (var groupIndex = 0; groupIndex < groups.length; groupIndex++) {
        group = groups[groupIndex];
        trigger = group.querySelector('[data-drawer-section-trigger]');
        sectionId = group.getAttribute('data-drawer-section-id');

        if (trigger && sectionId && state.sections && Object.prototype.hasOwnProperty.call(state.sections, sectionId)) {
          trigger.setAttribute('aria-expanded', state.sections[sectionId] ? 'true' : 'false');
        }
      }

      if (!accordion || !Object.prototype.hasOwnProperty.call(state, 'openCategory')) {
        return;
      }

      categoryItems = accordion.querySelectorAll('[data-drawer-category]');

      if (state.openCategory) {
        for (var itemIndex = 0; itemIndex < categoryItems.length; itemIndex++) {
          item = categoryItems[itemIndex];
          categoryId = item.getAttribute('data-drawer-category-id');

          if (categoryId === state.openCategory) {
            hasMatchedCategory = true;
            break;
          }
        }

        if (!hasMatchedCategory) {
          return;
        }
      }

      for (var categoryIndex = 0; categoryIndex < categoryItems.length; categoryIndex++) {
        item = categoryItems[categoryIndex];
        trigger = item.querySelector('[data-drawer-category-trigger]');
        categoryId = item.getAttribute('data-drawer-category-id');

        if (trigger && categoryId) {
          trigger.setAttribute('aria-expanded', categoryId === state.openCategory ? 'true' : 'false');
        }
      }
    }

    restoreDrawerState();

    function initSectionTrigger(trigger) {
      var group = trigger.closest('[data-drawer-group]');
      var panel = group ? group.querySelector('[data-drawer-section-panel]') : null;

      syncPanelState(panel, trigger.getAttribute('aria-expanded') === 'true');

      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        setSectionState(trigger, !expanded);
        persistDrawerState();
      });
    }

    var sectionTriggers = drawer.querySelectorAll('[data-drawer-section-trigger]');
    for (var i = 0; i < sectionTriggers.length; i++) {
      initSectionTrigger(sectionTriggers[i]);
    }

    if (!accordion) {
      return;
    }

    function initCategoryTrigger(trigger) {
      var item = trigger.closest('[data-drawer-category]');
      var panel = item ? item.querySelector('[data-drawer-category-panel]') : null;

      syncPanelState(panel, trigger.getAttribute('aria-expanded') === 'true');

      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-drawer-category]');
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var categoryItems = accordion.querySelectorAll('[data-drawer-category]');

        for (var k = 0; k < categoryItems.length; k++) {
          var otherItem = categoryItems[k];
          if (otherItem !== item) {
            setCategoryState(otherItem, false);
          }
        }

        setCategoryState(item, !expanded);
        persistDrawerState();
      });
    }

    var categoryTriggers = accordion.querySelectorAll('[data-drawer-category-trigger]');
    for (var j = 0; j < categoryTriggers.length; j++) {
      initCategoryTrigger(categoryTriggers[j]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-index"] && !Shopify.designMode) return;
  try {
    
  const saleWrap = document.getElementById('home-saleBannerWrap');

  if (saleWrap) {
    const saleCounting = document.getElementById('saleCounting');
    const saleEndDate = document.getElementById('saleEndDate');
    const saleNote = document.querySelector('.bt5-sale-note');
    const saleNoteBar = document.querySelector('.b5-sale-note-bar');
    const startDate = new Date(saleWrap.dataset.start).getTime();
    const endDate = new Date(saleWrap.dataset.end).getTime();
    const localDate = new Date().getTime();
    const countdownDisplayThreshold = 24 * 60 * 60 * 1000;
    const formatTwoDigits = function (n) {
      return n >= 0 && n < 10 ? '0' + n : '' + n;
    };

    if (!Number.isNaN(startDate) && !Number.isNaN(endDate) && endDate > localDate && startDate < localDate) {
      if (endDate - localDate < countdownDisplayThreshold && saleEndDate && saleNote && saleCounting) {
        saleEndDate.style.display = 'block';
        saleNote.style.display = 'none';

        const counting = setInterval(function () {
          const now = new Date().getTime();
          const distance = endDate - now;
          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          saleCounting.innerHTML =
            '<b>' +
            formatTwoDigits(days) +
            '</b>d <b>' +
            formatTwoDigits(hours) +
            '</b>h <b>' +
            formatTwoDigits(minutes) +
            '</b>m <b>' +
            formatTwoDigits(seconds) +
            '</b>s';

          if (distance < 0) {
            clearInterval(counting);
            saleWrap.style.display = 'none';
            if (saleNoteBar) {
              saleNoteBar.style.display = 'none';
            }
          }
        }, 1000);
      }

      saleWrap.style.display = 'block';
    } else {
      saleWrap.style.display = 'none';
    }
  }

  } catch(e) { console.error(e); }
})();
})();
